import {Component, ViewEncapsulation} from '@angular/core';

@Component({
    selector     : 'index',
    encapsulation: ViewEncapsulation.None,
    template: ``
})
export class IndexComponent {

    constructor() {

    }

}
